import { useApi } from '@/hooks/useApi';
import { useModeAwareMutation } from '@/hooks/useModeAwareQuery';

export interface EmailMergeRecipientRequest {
  recipientId: string;
  recipientEmail: string;
  customerId: number;
  contactId?: number;
  transactionIds?: number[];
}

export interface EmailMergeDataRequest {
  sourceType: string;
  sourceId?: number;
  templateId?: number;
  subject?: string;
  body?: string;
  recipients: EmailMergeRecipientRequest[];
}

export interface EmailMergeRecipientResponse {
  recipientId: string;
  mergeData: Record<string, string>;
  mergeDataHtml?: Record<string, string>;
}

export interface EmailMergeDataResponse {
  recipients: EmailMergeRecipientResponse[];
  unknownPlaceholders: string[];
  emptyDataPlaceholders: string[];
}

export function useEmailMergeData() {
  const { apiPost } = useApi();

  return useModeAwareMutation<EmailMergeDataResponse, Error, EmailMergeDataRequest>(
    async (request) => {
      return apiPost<EmailMergeDataResponse>('/api/v1/email/merge-data', request);
    },
    (request) => {
      return {
        recipients: request.recipients.map((r) => ({
          recipientId: r.recipientId,
          mergeData: { email: r.recipientEmail },
          mergeDataHtml: {},
        })),
        unknownPlaceholders: [],
        emptyDataPlaceholders: [],
      };
    },
  );
}
